import api from '@/api/api';
import Vue from 'vue';
import shopCartApi from '@/api/shopCart/api.shopCart'

const GETCARTINFO 				= 'GETCARTINFO'
const ADDTOCART 				= 'ADDTOCART';
const GETCARTNUM 				= 'GETCARTNUM';
const GETPARTLIST  				= 'GETPARTLIST';
const DELCARTITEM 				= 'DELCARTITEM';

const UPDATECARTITEM 			= 'UPDATECARTITEM';

const GETFIRMORDER 				= 'GETFIRMORDER';
const SETORDERADDRESS 			= 'SETORDERADDRESS';
const UPDATEBIRTHCARD 			= 'UPDATEBIRTHCARD';
const UPADTEGREETINGCARD 		= 'UPADTEGREETINGCARD';
const UPDATENUM 				= 'UPDATENUM';



// import shopCartMock from '../../Mock/shopCartMock'

export default {
	state: {
		counter: 0,//购物车商品总数
		shopCartList: [],//商品列表信息
		partList: [],//配件列表

		finalOrderPrice: 0,//最终订单价
		freight: 0,//运费
		totalPrice: 0,//商品总价
		itemGsTypes: [],//购物车商品类型集合

		firmOrder: {},//确认订单礼盒列表信息
		firmTotalAmount: 0,//
		hasOwnDelivery: false,//是否有自营配送订单

		orderAddress: {},//订单地址

	},
	getters:{
		unPurPartList:(state, getters)=>{
			const list = [];
			state.shopCartList.map((item,index)=>{
				if(!item.purchasableParts&&item.saleStatus==2&&!item.parts){
					list.push(item)
				}
			})
			return list;
		},
		purPartList:(state, getters)=>{
			const list = [];
			state.shopCartList.map((item,index)=>{
				if(item.purchasableParts&&item.saleStatus==2&&!item.parts){
					list.push(item)
				}
			})
			return list;
		},
		shopCartPartList: (state, getters)=>{
			const list = [];
			state.shopCartList.map((item,index)=>{
				if(item.saleStatus==2&&item.parts){
					list.push(item)
				}
			})
			return list;
		},
		noSaleList: (state,getter)=>{
			const list = [];
			state.shopCartList&&state.shopCartList.map((item,index)=>{
				if(item.saleStatus==1){
					list.push(item)
				}
			})
			return list;
		},
		tempCheckShopList: (state,getter)=>{//用于记录除下架的以外人所有商品
			const list = [];
			state.shopCartList.map((item,index)=>{
				if(item.saleStatus==2){
					list.push(item)
				}
			})
			return list;
		},
		isPurPartChecked: ( state, getter)=>{
			const { purPartList } = getter;
	    	let pruCheckedList = [];
				purPartList.map((item,index)=>{
					if(item.checked) {
						pruCheckedList.push(item)
					}
				}) 

			return pruCheckedList.length > 0 ? true : false;
		}
	},
	actions: {
		getCartNum({commit}){//获取购产车商品数
            shopCartApi.getCount({},function(res){
				var res = res.body;
				commit('GETCARTNUM',res.data.cartCount);
			})
		},
		addCart({ commit },proSku){//添加商品到购物车
			return new Promise(function(resolve, reject){
               shopCartApi.addToCart(proSku,function(res){
					var res = res.body;
					console.log(proSku[0].goodsNum);
					commit('ADDTOCART',proSku[0].goodsNum);
					resolve(res);
				},function(err){
					var res = err.body;
					reject(res.meta.msg)
				},false)
			})
		},
		updateBirthText({ commit },params){//设置生日牌
			console.log('updateBirthText',params);
			return new Promise(function(resolve, reject){
				shopCartApi.updateCartItem(params,function(res){
					var res = res.body;
					commit('UPDATEBIRTHCARD',{
						data: res.data,
						params
					})
					resolve(res);
				})
			})
		},

		updateGreetingCard( { commit }, params){//设置祝福卡
			console.log('updateGreetingCard',params);
			shopCartApi.updateCartItem(params,function(res){
				var res = res.body;
				commit('UPADTEGREETINGCARD',{
					params
				})
			})

		},
		updateNum( { commit }, params ){ //修改数量
			shopCartApi.updateCartItem(params,function(res){
				var res = res.body;
				commit('UPDATENUM',{
					params,
					data: res.data
				})
			})

		},
		delCartItem({ commit },params){ //删除商品 
			console.log('delCartItem',params);
			return new Promise(function(resolve, reject){
				shopCartApi.delCartItem(params,function(res){
					var res = res.body;
					commit('DELCARTITEM',{
						params,
						data: res.data
					});
					resolve(res);
				})
			})
		},
		getCartInfo( {commit}){//获取购物车列表信息
			return new Promise(function(resolve,reject){
				shopCartApi.getCartInfo({},function(res){
					var res = res.body;
					console.log(res.data)
					commit('GETCARTINFO',res.data);
					resolve();
				})
			})
		},
		//是否选择 全选 
		// updateCartItem( { commit}, params ){//
		updateCheckItem( { commit}, params ){//
			const upInfo = params;
			delete upInfo.uniqueId;
			return new Promise(function(resolve,reject){
				shopCartApi.updateCheckItem(upInfo,function(res){
					var res = res.body;
					commit('UPDATECARTITEM',{
						data:res.data,
						params
					})
					resolve(res);
				})
			})
		},

		//获取地址信息
		getFirmOrderAddress( {commit,state },params){
			//code 03206 说明用户无收货地址 code 03209 说明没有匹配到当前区域的收货地址
			return new Promise(function(resolve,reject){
				shopCartApi.getFirmOrderAddress(params,function(res){
					var res = res.body;
					if (res.data) {
			            commit('SETORDERADDRESS',res.data);
			            if(res.meta.code){
			              resolve(res.meta.code)
			            }
			          } else {
			            state.orderAddress = {}
			            resolve('03209')
			          }
					
				},function(err){
					var res = err.body;
					state.orderAddress = {};
					resolve(res.meta.code)
				},false)
			})
		},
		//获取确认订单详细信息
		getFirmOrder({ commit }){
			return new Promise(function(resolve,reject){
				shopCartApi.getFirmOrder('',function(res){
					var res = res.body;
					resolve();
					commit('GETFIRMORDER',res.data)
				})
			})
		},
		getDeliveryTimer({ commit },parma){
			return new Promise(function(resolve,reject){
				shopCartApi.getDeliveryTimer(parma,function(res){
					var res = res.body;
					resolve(res.data);
				})
			})
		},
		setOrderAddress({ commit },data){
			commit('SETORDERADDRESS',data)
		},
		confirmOrder({ commit },parma){
			return new Promise(function(resolve,reject){
				shopCartApi.submitOrder(parma,function(res){
					var res = res.body;
					resolve(res.data);
				},function(err){
					var res = err.body;
					reject(res.meta)
				},false)
			})
		},
		goOrder({ commit },params){
			console.log('goOrder',params);
			return new Promise(function(resolve,reject){
				shopCartApi.goOrder(params,function(res){
					resolve();
				})
			})
		}
	},
	mutations:{
		[GETCARTNUM](state,num){
			state.counter = parseInt(num);
		},
		[ADDTOCART]( state, options){
			state.counter += parseInt(options);
		},
		[GETCARTINFO](state,data){
			
			let { goodsList, partsList } = data;

			goodsList&&goodsList.map((item,index)=>{
				item.uniqueId = item.goodsChannelId+(item.skuId?item.skuId:0);
				item.birthdayCardContent = item.birthdayCardContent || ''
			})
			

			state.partList 		= partsList ? partsList : []; //配件列表
			state.shopCartList =  goodsList ? goodsList : [];
			state.finalOrderPrice = data.shopCartFeeInfo ? data.shopCartFeeInfo.totalAmount : 0;
			state.freight = data.shopCartFeeInfo ? data.shopCartFeeInfo.freight : 0;
			state.totalPrice = data.shopCartFeeInfo ? data.shopCartFeeInfo.goodsTotalPrice : 0;

		},
		[GETPARTLIST](state,data){
			// state.partList = data;
		},
		[UPDATECARTITEM](state,{data,params}){
			state.finalOrderPrice = data.totalAmount;//最终订单价
			state.freight =  data.freight;//运费
			state.totalPrice = data.goodsTotalPrice;//商品总价
			
			const { shopCartCheckItems } = params;
			const { shopCartList } = state;

			shopCartCheckItems.map((item,index)=>{
				shopCartList.map((cartItem,cartIndex)=>{
					if(item.uniqueId == cartItem.uniqueId){
						cartItem.checked = item.checked;
					}
				})
			})
			
			let pruPartList = []
			shopCartList.map((item,index)=>{
				if(item.purchasableParts&&item.saleStatus==2&&!item.parts&&item.checked){
					pruPartList.push(item)
				}
			})

			if(pruPartList.length < 1){
				shopCartList.map((item,index)=>{
					if(item.parts){
						item.checked = false;
					}
				})

			}

			state.shopCartList = shopCartList;
		},
		[DELCARTITEM](state,{params,data}){

			state.finalOrderPrice = data.totalAmount;//最终订单价
			state.freight =  data.freight;//运费
			state.totalPrice = data.goodsTotalPrice;//商品总价
			
		},
		[GETFIRMORDER](state,resObj){
			console.log(data);
			let data = resObj;
			let orderInfo = data.preOrderInfos;
			orderInfo.map((item,index)=>{
				// 1-自营配送,2-快递寄送,3-虚拟产品不配送
				const deliveryType = item.deliveryType;
				if(deliveryType == 1){
					item.deliveryTypeDesc = '自营配送'
				}else if(deliveryType == 2){
					item.deliveryTypeDesc = '快递配送'
				}else if(deliveryType == 3){
					item.deliveryTypeDesc = '不配送'
				}else{
					item.deliveryTypeDesc = ''
				}
			})

			data.preOrderInfos = orderInfo;
			state.firmOrder = data;
			state.firmTotalAmount = data.shopCartFeeInfo.totalAmount;
			
			let hasOwnDelivery = false;
			const { preOrderInfos } = data;
			hasOwnDelivery = preOrderInfos.some((item,index)=>item.deliveryType==1);
			state.hasOwnDelivery = hasOwnDelivery;

		},
		[SETORDERADDRESS](state,data){
			state.orderAddress = data;
		},
		[UPDATEBIRTHCARD](state, data){
			const { params } = data;
			let { shopCartList } = state;
			shopCartList.map((cartItem,cartIndex)=>{
				if(params.uniqueId == cartItem.uniqueId){
					cartItem.birthdayCardContent = params.birthdayCardContent;
				}
			})
			state.shopCartList = shopCartList;
		},
		[UPADTEGREETINGCARD](state,data){
			const { params } = data;
			let { shopCartList } = state;
			shopCartList.map((cartItem,cartIndex)=>{
				if(params.uniqueId == cartItem.uniqueId){
					cartItem.greetingCardContent = params.greetingCardContent;
				}
			})
			state.shopCartList = shopCartList;
		},
		[UPDATENUM](state,{data,params}){
		
			let { shopCartList } = state;
			shopCartList.map((cartItem,cartIndex)=>{
				if(params.uniqueId == cartItem.uniqueId){
					cartItem.goodsNum = params.goodsNum;
				}
			})
			state.shopCartList = shopCartList;
			state.finalOrderPrice = data.totalAmount;//最终订单价
			state.freight =  data.freight;//运费
			state.totalPrice = data.goodsTotalPrice;//商品总价
		}
	}
}  		
    	
    


// WEBPACK FOOTER //
// ./src/js/store/shopCart.js